import Constants from 'client/util/Constants';
import Vue from 'vue';

const { error, success } = Constants;

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const RESET_MESSAGES = 'RESET_MESSAGES';

const initialState = () => ({
  alerts: [],
});

export const createAlertModule = () => ({
  namespaced: true,
  state: initialState(),
  actions: {
    resetAlerts() {},
    triggerAlert({ commit }, alert) {
      commit(ADD_MESSAGE, alert);
    },
    triggerErrorAlert({ dispatch }, message) {
      dispatch('triggerAlert', { type: error, message });
    },
    triggerSuccessAlert({ dispatch }, message) {
      dispatch('triggerAlert', { type: success, message });
    },
  },
  mutations: {
    [ADD_MESSAGE]: (state, alert) => {
      state.alerts.push({ ...alert });
    },
    [RESET_MESSAGES]: (state) => {
      Vue.set(state, 'alerts', initialState().alerts);
    },
  },
});

export default createAlertModule();
